module.exports = __webpack_public_path__ + "img/t2-16.b28feea6.svg";